<template>
  <!-- 课程分类抽屉 -->
  <div v-if="drawer" class="fixed inset-0 z-[2000] flex justify-end classify-drawer-overlay" :class="{ 'electron-drawer-overlay': isElectron }">
    <!-- Backdrop -->
    <div
      class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity"
      @click="handleClose"
    ></div>

    <!-- Drawer Panel -->
    <div
      :class="[
        'relative h-full shadow-2xl overflow-hidden flex flex-col border-l border-white/20 dark:border-slate-700 bg-white dark:bg-slate-900 animate-slide-in',
        isH5 ? 'w-full rounded-none h5-classify-drawer' : 'classify-drawer-panel'
      ]"
    >

      <!-- Header -->
      <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between bg-white/95 dark:bg-slate-900/95 backdrop-blur-md sticky top-0 z-10">
        <div class="flex items-center gap-1 md:gap-3">
          <div class="w-10 h-10 rounded-full bg-brand-50 dark:bg-brand-900/30 flex items-center justify-center text-brand-600 dark:text-brand-400">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
          </div>
          <div>
            <h2 class="text-xl font-black text-slate-800 dark:text-slate-100 tracking-tight">全部分类</h2>
            <p class="text-xs text-slate-400 dark:text-slate-500 font-medium">定制您的专属兴趣频道</p>
          </div>
        </div>
        <span
          @click="handleClose"
          class="drawer-icon-btn md:p-2 rounded-full text-slate-400 transition-colors cursor-pointer"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </span>
      </div>

      <!-- Content -->
      <div class="flex-1 overflow-y-auto p-6 space-y-10 classify-drawer-scroll">

        <!-- My Categories Section -->
        <section class="animate-fade-in-up">
          <div class="flex items-center justify-between mb-1 md:mb-4">
            <div class="flex items-end gap-1 md:gap-2">
              <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">我的频道</h3>
              <span class="text-xs text-slate-400 dark:text-slate-500 font-medium md:mb-1">点击移除，拖拽排序</span>
            </div>
            <span
              class="drawer-icon-btn flex items-center gap-1 text-xs font-semibold text-slate-400 hover:text-brand-600 px-2 py-1 transition-colors cursor-pointer"
              @click="resetToDefault"
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
              恢复默认
            </span>
          </div>

          <draggable
            v-if="myClassify.length"
            :options="{
              group: 'title',
              animation: 300,
              ghostClass: 'sortable-ghost',
            }"
            :no-transition-on-drag="true"
            :list="myClassify"
            @change="onDragChange"
          >
            <transition-group class="flex flex-wrap gap-3 min-h-[60px] content-start" type="transition">
              <div
                v-for="(item, index) in myClassify"
                :key="item.id"
                class="group relative flex items-center gap-1.5 pl-4 pr-2 py-2.5 bg-slate-100 dark:bg-slate-800 hover:bg-rose-50 dark:hover:bg-rose-900/20 hover:text-rose-600 text-slate-700 dark:text-slate-300 border border-transparent hover:border-rose-200 dark:hover:border-rose-800 rounded-xl font-bold text-sm select-none animate-scale-in cursor-pointer transition-all active:scale-95"
                @click="deleteMyclassify(index, item)"
              >
                {{ item.category_name }}
                <div class="p-0.5 rounded-full text-slate-400 group-hover:text-rose-500 transition-colors">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div v-else class="w-full h-20 border-2 border-dashed border-slate-200 dark:border-slate-700 rounded-xl flex items-center justify-center text-slate-400 dark:text-slate-500 text-sm">
            请从下方选择您感兴趣的分类
          </div>
        </section>

        <!-- Divider -->
        <div class="h-px bg-slate-100 dark:bg-slate-700"></div>

        <!-- All Categories Section -->
        <section class="md:space-y-8 animate-fade-in-up delay-100">
          <div class="flex items-center gap-2 text-slate-400 text-sm font-medium">
            <span>推荐频道</span>
            <span class="flex-1 h-px bg-slate-100 dark:bg-slate-700"></span>
            <span>点击添加</span>
          </div>

          <div
            v-for="(category, pIndex) in categoryList"
            :key="category.id"
            class="md:space-y-4"
          >
            <div class="flex items-center gap-2">
              <div
                class="w-1.5 h-4 rounded-full"
                :class="groupColors[pIndex % groupColors.length]"
              ></div>
              <h4 class="font-semibold text-slate-700 dark:text-slate-300 text-sm">{{ category.category_name }}</h4>
            </div>

            <div v-if="category.child && category.child.length" class="flex flex-wrap gap-1 md:gap-3">
              <template v-for="(item, subIndex) in category.child">
                <span
                  v-if="item.isAdded !== 1"
                  :key="item.id"
                  @click="addClassify(item, pIndex, subIndex)"
                  class="drawer-cat-btn flex items-center gap-1.5 px-4 py-2.5 bg-white dark:bg-slate-800 hover:bg-brand-50 dark:hover:bg-brand-900/20 hover:text-brand-600 dark:hover:text-brand-400 rounded-xl text-slate-600 dark:text-slate-400 text-sm font-medium transition-all hover:shadow-sm hover:-translate-y-0.5 active:translate-y-0 group cursor-pointer select-none"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-slate-400 group-hover:text-brand-500 transition-colors"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  {{ item.category_name }}
                </span>
              </template>
            </div>

            <p v-if="category.isAllAdded" class="text-xs text-slate-400">
              已全部添加至 "我的频道"
            </p>
          </div>
        </section>
      </div>

      <!-- Footer Actions -->
      <div class="p-6 border-t border-slate-100 dark:border-slate-700 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md sticky bottom-0 z-10">
        <button
          @click="submitCategory"
          v-preventReClick
          :disabled="submiting"
          :class="[
            'w-full py-3.5 rounded-2xl font-bold text-lg shadow-xl transition-all active:scale-95 flex items-center justify-center gap-2',
           isModified
              ? 'bg-brand-600 hover:bg-brand-500 text-white shadow-brand-500/20'
              : 'bg-slate-900 dark:bg-slate-800 text-white hover:bg-slate-800 dark:hover:bg-slate-700'
          ]"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          {{ isModified ? '保存修改' : '完成' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
import {
  getCategoryList,
  getCategoryTree,
  saveCategory,
} from "@saas/service-api/src/category";
import { getLocalCategories, saveLocalCategories } from "../utils/categoryStorage";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
  data: function () {
    return {
      isH5: isH5(),
      isElectron: window.isElectron,
      drawer: false,
      myClassify: [],
      categoryList: [],
      initData: [], //初始化数据
      submiting: false,
      isModified: false,
      groupColors: [
        'bg-blue-500',
        'bg-purple-500',
        'bg-orange-500',
        'bg-green-500',
        'bg-pink-500',
        'bg-cyan-500',
      ],
    };
  },
  watch: {
    drawer(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    },
  },
  methods: {
    onDragChange() {
      this.isModified = true;
    },
    resetToDefault() {
      this.myClassify = [];
      this.categoryList = [];
      this.isModified = true;
      // 只改内存数据，不动 localStorage（用户点"保存"时才写）
      getCategoryTree().then((res) => {
        if (res.code === 1) {
          const defaults = [];
          (res.data || []).forEach((group) => {
            if (group.child?.length) {
              group.child.forEach((child) => {
                if (child.is_def) {
                  defaults.push({
                    id: child.id,
                    category_name: child.category_name,
                    pid: group.id,
                  });
                }
              });
            }
          });
          this.myClassify = defaults;
          // 直接复用已拿到的 tree 数据，不再重复请求
          this.applyCategoryTree(res.data || []);
        }
      });
    },
    deleteMyclassify(index, item) {
      if (this.myClassify.length <= 1) {
        this.$message.warning("最少需要保留 1 个分类");
        return;
      }
      this.myClassify.splice(index, 1);
      this.isModified = true;
      let pIndex = this.categoryList.findIndex((category) => {
        return category.id === item.pid;
      });
      if (pIndex !== -1 && this.categoryList[pIndex]?.child?.length) {
        let subIndex = this.categoryList[pIndex].child.findIndex((child) => {
          return child.id === item.id;
        });
        if (subIndex !== -1) {
          this.categoryList[pIndex].child[subIndex].isAdded = 0;
          if (this.categoryList[pIndex].isAllAdded) {
            this.$set(this.categoryList[pIndex], "isAllAdded", false);
          }
        }
      }
    },
    submitCategory() {
      if (this.submiting) return;
      this.submiting = true;
      let category_id = [];
      this.myClassify.forEach((item) => {
        category_id.push(item.id);
      });
      if (!category_id.length) {
        this.$message.warning("最少需要添加 1 个分类");
        this.submiting = false;
        return false;
      }
      let params = {
        category_id,
      };
      // 始终写 localStorage（保证退出登录后数据一致）
      saveLocalCategories(this.myClassify.map(c => ({ id: c.id, category_name: c.category_name, pid: c.pid })));

      if (!this.isAuthenticated) {
        // 未登录：只用 localStorage
        this.$message.success("保存成功");
        this.$emit("saveCategory");
        this.inintDrawerData();
        return;
      }
      // 已登录：同时保存到服务端
      saveCategory(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("保存成功");
            this.$emit("saveCategory");
            this.inintDrawerData();
          } else {
            this.$message.error(res.message);
            this.submiting = false;
          }
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    addClassify(item, pIndex, subIndex) {
      if (!(this.myClassify.length < 20)) {
        this.$message.warning("最多添加20个分类");
        return false;
      }
      this.myClassify.push({
        id: item.id,
        category_name: item.category_name,
        pid: this.categoryList[pIndex].id,
      });
      this.$set(this.categoryList[pIndex].child[subIndex], "isAdded", 1);
      this.categoryList[pIndex].isAllAdded = this.categoryList[
        pIndex
      ].child.every((item) => {
        return item.isAdded === 1;
      });
      this.isModified = true;
    },
    handleClose(type) {
      if (type !== "save") {
        // 校验我的分类是否改变
        let arr = [];
        this.myClassify.forEach((item) => {
          arr.push(item.id);
        });
        if (arr.join(",") !== this.initData.join(",")) {
          this.$confirm(
            "我的分类已经编辑过，离开将无法保存这些改动，是否保存？",
            "提示",
            {
              confirmButtonText: "保存",
              cancelButtonText: "离开",
              dangerouslyUseHTMLString: true,
              type: "warning",
              closeOnClickModal: false,
            }
          )
            .then(() => {
              this.submitCategory();
            })
            .catch(() => {
              this.inintDrawerData();
            });
        } else {
          this.inintDrawerData();
        }
      } else {
        this.inintDrawerData();
      }
    },
    inintDrawerData() {
      this.drawer = false;
      this.myClassify = [];
      this.categoryList = [];
      this.initData = [];
      this.isModified = false;
      setTimeout(() => {
        this.submiting = false;
      }, 100);
    },
    openDrawer() {
      this.drawer = true;
      this.isModified = false;
      this.apiGetCategoryList();
    },
    apiGetCategoryList() {
      // localStorage 有数据就优先用（保证和 tab 栏一致）
      const localData = getLocalCategories();
      if (localData.length) {
        this.myClassify = localData;
        this.apiGetCategoryTree();
        return;
      }
      getCategoryList().then((res) => {
        if (res.code === 1) {
          this.myClassify = res.data || [];
          this.apiGetCategoryTree();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetCategoryTree() {
      getCategoryTree().then((res) => {
        if (res.code === 1) {
          this.applyCategoryTree(res.data || []);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 将 tree 数据标记 isAdded 并写入 categoryList
    applyCategoryTree(data) {
      this.categoryList = data;
      if (data?.length && this.myClassify?.length) {
        this.myClassify.forEach((item) => {
          this.initData.push(item.id);
          let index = this.categoryList.findIndex((category) => {
            return category.id === item.pid;
          });
          if (index !== -1 && this.categoryList[index]?.child?.length) {
            let subIndex = this.categoryList[index].child.findIndex(
              (child) => {
                return child.id === item.id;
              }
            );
            if (subIndex !== -1) {
              this.categoryList[index].child[subIndex].isAdded = 1;
            }
            this.categoryList[index].isAllAdded = this.categoryList[
              index
            ].child.every((item) => {
              return item.isAdded === 1;
            });
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  components: {
    draggable,
  },
  beforeDestroy() {
    document.body.style.overflow = 'unset';
  },
};
</script>

<style lang="scss" scoped>
@keyframes slide-in {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
@keyframes scale-in {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
@keyframes fade-in-up {
  from { transform: translateY(10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.animate-slide-in {
  animation: slide-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.animate-scale-in {
  animation: scale-in 0.2s ease-out;
}
.animate-fade-in-up {
  animation: fade-in-up 0.4s ease-out forwards;
}
.delay-100 {
  animation-delay: 100ms;
}
.sortable-ghost {
  opacity: 0;
}

.classify-drawer-scroll {
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 4px;
  }
}

// Icon / action spans (替换 button 以避免 Element UI 样式污染)
.classify-drawer-overlay {
  .drawer-icon-btn {
    display: inline-flex;
    align-items: center;
    user-select: none;
    -webkit-user-select: none;
    &:hover {
      color: #374151; // slate-700
    }
    &.rounded-full:hover {
      background: #f1f5f9; // slate-100
    }
  }
  .drawer-cat-btn {
    display: inline-flex;
    border: 1px solid #e2e8f0 !important; // slate-200，对齐设计
    border-radius: 0.75rem !important;
    outline: none !important;
    &:hover {
      border-color: #a7f3d0 !important; // brand-200
    }
  }
}

html.dark .classify-drawer-overlay {
  .drawer-icon-btn {
    &:hover {
      color: #e2e8f0; // slate-200
    }
    &.rounded-full:hover {
      background: #1e293b; // slate-800
    }
  }
  .drawer-cat-btn {
    border-color: #334155 !important; // slate-700
    &:hover {
      border-color: rgba(16, 185, 129, 0.3) !important; // brand-900/30
    }
  }
}

// 抽屉面板 — 使用 CSS 变量
.classify-drawer-panel {
  width: 100%;
  max-width: var(--drawer-width, 500px);
  border-radius: var(--drawer-radius, 2rem) 0 0 var(--drawer-radius, 2rem);
}

// Electron — 抽屉不遮挡 sidebar 和顶部导航栏
.electron-drawer-overlay {
  left: var(--side-bar-width, 70px) !important;
  top: 60px !important; // $nav-height in renderer-app
  right: 0 !important;
  bottom: 0 !important;
  // 解除 #electron-main 的 stacking context 影响
  position: fixed;
  z-index: 2001;
}

// H5 移动端适配 — 将 Tailwind rem 值覆盖为 px 值
.h5-classify-drawer {
  // Header
  .px-6.py-5 {
    padding: 12px 16px !important;
  }
  .w-10.h-10 {
    width: 32px !important;
    height: 32px !important;
  }
  .text-xl {
    font-size: 16px !important;
    line-height: 1.4;
  }
  .text-xs {
    font-size: 10px !important;
    line-height: 1.4;
  }

  // Content scrollable area
  .flex-1.overflow-y-auto {
    padding: 16px !important;
    gap: 24px !important;
  }

  // Section titles
  .text-lg {
    font-size: 14px !important;
    line-height: 1;
  }

  // Tags / chips (my channel items)
  .flex.flex-wrap.gap-3 {
    gap: 8px !important;
  }
  .pl-4.pr-2.py-2\.5 {
    padding: 6px 6px 6px 10px !important;
    font-size: 12px !important;
    line-height: 1.4;
    border-radius: 8px !important;
  }

  // Available category items
  .px-4.py-2\.5 {
    padding: 6px 10px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
  }

  // Divider label row
  .text-sm.font-medium {
    font-size: 11px !important;
    line-height: 1.4;
  }

  // Category group header
  h4 {
    font-size: 12px !important;
  }
  .w-1\.5.h-4 {
    width: 3px !important;
    height: 12px !important;
  }

  // Empty state placeholder
  .h-20 {
    height: 50px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
  }

  // Footer
  .p-6.border-t {
    padding: 12px 16px !important;
  }
  .py-3\.5 {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    font-size: 14px !important;
    border-radius: 12px !important;
  }
  .space-y-10 > :not([hidden]) ~ :not([hidden]){
    margin: 10px 0;
  }
}
</style>
